import extend from 'lodash/extend';
import get from 'lodash/get';
import { handleActions } from 'redux-actions';
import type { Action } from '../actions/index';
export const defaultState = '';
export type ModalState = {
  [key: string]: any;
} | {};
export default handleActions<ModalState, Action>({
  // @ts-expect-error todo(ts-migration) TS2322 Type '(state: ModalState, action: Action) => ModalState' is not assignable to type 'ReducerMapValue<ModalState, Action>'.
  setModal: (state: ModalState, action: Action): ModalState => {
    const meta = get(action, 'payload.meta') || {};
    const type = get(action, 'payload.type') || '';
    return extend({}, state, {
      [type]: meta
    });
  }
}, {});